import auth from './auth';
import providers from './providers';

const middleware = (to, next, router) => {
  const userToken = localStorage.getItem('user-token') || '';
  const access = to.meta.middleware.access;

  if (access === 'guest') {
    providers.setTitle(to);
    !userToken ? next() : next({ name: 'welcome_page' });
  }

  if (access === 'auth') {
    auth({ to, next, router }, userToken);
  }

  return false;
};

export default middleware;
